import { buildService } from './decorated-service';
import {
  StaticDirectRolloverApplication,
  StaticIndirectRolloverApplication,
  OptionalDirectRolloverApplication,
  OptionalIndirectRolloverApplication,
  DirectRolloverApplication,
  IndirectRolloverApplication
} from '../../../core/types/applications/rollover-application';
import {
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';
import { consumerTypes } from '../utils';

const api = buildService(
  '/new-account-svc/service/v2/account/mutualfund-rollover-ira'
);

const fonasuApi = buildService(
  '/new-account-svc/service/front-office/v2/account/mutualfund-rollover-ira'
);

export const getValidated = (
  args: OptionalDirectRolloverApplication | OptionalIndirectRolloverApplication
): StaticDirectRolloverApplication | StaticIndirectRolloverApplication => {
  if (args.rolloverType === 'INDIRECT') {
    return IndirectRolloverApplication.check(args);
  }

  return DirectRolloverApplication.check(args);
};

// TODO [2021-02-01]: register flow with new Retirment Transfer Application State using generics
export const createRolloverApplicationService = (
  args: OptionalDirectRolloverApplication | OptionalIndirectRolloverApplication,
  consumerName
): Promise<any> => {
  // TODO [2021-02-01]: register flow with new generic types for account type submissions
  const validated = getValidated(args);
  const submissionPayload = purgeEmptyFields(validated);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  const apiEndpoint = consumerName === consumerTypes.FONASU ? fonasuApi : api;

  return apiEndpoint.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
